import classnames from 'classnames'
import { ComponentProps, FC } from 'react'

import cls from './TextPromo.module.scss'

interface TextProps extends ComponentProps<'div'> {
  size?:
    | 's12'
    | 's14'
    | 's16'
    | 's18'
    | 's20'
    | 's22'
    | 's23'
    | 's24'
    | 's28'
    | 's30'
    | 's32'
    | 's36'
    | 's40'
    | 's48'
    | 's44'
    | 's48'
    | 's56'
    | 's64'
    | 's60'
    | 's70'
    | 's96'
    | 's103'
    | 's106'
    | 's128'
  color?: 'default' | 'white' | 'primary' | 'gray' | 'blue' | 'greyInvert' | 'darkGray'
  weight?: 'w400' | 'w500' | 'w550' | 'w700'
  fontFamily?: 'ASLHauss' | 'Unbounded' | 'ASLHaussVF'
  pointer?: boolean
  center?: boolean
  underline?: boolean
}

export const TextPromo: FC<TextProps> = ({
  children,
  size = 'medium',
  color = 'default',
  fontFamily = 'Unbounded',
  weight = '400',
  className,
  pointer = false,
  center,
  underline,
  ...props
}) => {
  const classes = classnames(cls.text, cls[`text--${size}`], cls[`text--${color}`], className, [
    cls[`text--${fontFamily}`],
    cls[`text--${weight}`],
    {
      [cls.pointer]: pointer,
      [cls.center]: center,
      [cls.underline]: underline,
    },
  ])

  return (
    <span className={classes} {...props}>
      {children}
    </span>
  )
}
